module.exports = __webpack_public_path__ + "img/camp_shirt_other3.c7245964.svg";